var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Confirm your changes")]),
    _c("div", { staticClass: "confirmation-details" }, [
      _c("p", [
        _c("strong", [_vm._v("Action:")]),
        _vm._v("\n            " + _vm._s(_vm.actionName) + "\n        "),
      ]),
      _vm.selectedActionIndex === 0
        ? _c("p", [
            _c("strong", [_vm._v("Driver:")]),
            _vm._v(
              "\n            " + _vm._s(_vm.selectedDriverName) + "\n        "
            ),
          ])
        : _vm._e(),
      _vm.selectedActionIndex === 1
        ? _c("p", [
            _c("strong", [_vm._v("Status:")]),
            _vm._v(
              "\n            " + _vm._s(_vm.selectedStatus) + "\n        "
            ),
          ])
        : _vm._e(),
      _vm.selectedActionIndex === 2
        ? _c("p", [
            _c("strong", [_vm._v("Note Type:")]),
            _vm._v(
              "\n            " + _vm._s(_vm.selectedNoteType) + "\n        "
            ),
          ])
        : _vm._e(),
      _vm.selectedActionIndex === 2
        ? _c("p", [
            _c("strong", [_vm._v("Note:")]),
            _vm._v("\n            " + _vm._s(_vm.selectedNote) + "\n        "),
          ])
        : _vm._e(),
      _vm.selectedActionIndex === 5
        ? _c("p", [
            _c("strong", [_vm._v("Date:")]),
            _vm._v("\n            " + _vm._s(_vm.formattedDate) + "\n        "),
          ])
        : _vm._e(),
      _c("p", [
        _c("strong", [_vm._v("Records affected:")]),
        _vm._v(
          "\n            " +
            _vm._s(_vm.selectedRows.length + " selected records") +
            "\n        "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }